import get from 'lodash.get';

const getBrandedHeaderLimit = (rootState) =>
  get(rootState, 'ws.integration.settings.limits.brandedHeader', null);

export default getBrandedHeaderLimit;
